<script>
  //export let archetypesAbbreviations;

  //let lowerCasedArchAbbr = archetypesAbbreviations.toLowerCase();

  import * as testContents from "../configs/testItems.json";
  import * as typologies from "../configs/typologies.json";
  import * as conversions from "../configs/conversions.json";

  import { Link } from "svelte-routing";

  /*console.log(conversions);*/

  let archetypesAbbreviations = "";

  let vangaurdguments = new URLSearchParams(window.location.search);

  for (let sect of testContents.default) {
    let sectScore = vangaurdguments.get(sect.heading);
    for (let phylum of sect.classes) {
      if (phylum.min <= sectScore && sectScore <= phylum.max) {
        archetypesAbbreviations += phylum.abbreviation;
        break;
      }
    }
  }

  //console.log(archetypesAbbreviations);

  import GenderSelect from "../ponents/GenderSelect.svelte";
  import StatsBars from "../ponents/StatsBars.svelte";

  import SelectedGender from "../stores/Persistent";

  /*
  $: archsCharsName = (typologies.default[archetypesAbbreviations] ?? {
    m: { name: "-" },
    f: { name: "-" },
  })[$SelectedGender].name;
  */
  $: archsCharsName =
    typologies.default[archetypesAbbreviations][$SelectedGender].name;

  import ArchetypicalCharactersCard from "../ponents/ArchetypicalCharactersCard.svelte";

  //import {convertAbbreviated,fullstopize} from "../global";

  import Initialism from "../ponents/Initialism.svelte";

  //

  import Test from "../ponents/Test.svelte";

  let percentilesArray;

  import { decompressServe, fixAWSdataStructure } from "../global";
  import { onMount } from "svelte";
  fetch("/api/database-read?realm=test-items")
    .then(function (response) {
      if (response.ok) {
        return response.text();
      }
      throw new Error("Something went wrong");
    })
    .then(function (compressed) {
      const json = fixAWSdataStructure(decompressServe(compressed));
      function percentile(axis, number) {
        return (
          (100 *
            json
              .map(
                (take) =>
                  testComponent.scores(
                    Object.fromEntries(
                      take.map((linkage) => [linkage.key, linkage.value])
                    )
                  )[axis]
              )
              .filter((n) => number > n).length) /
          json.length
        );
      }
      percentilesArray = Array.from(vangaurdguments.entries()).map(([k, v]) =>
        percentile(k, v)
      );
    });

  let testComponent;

  import { adsConfig } from "../stores/Store";
  onMount(() => {
    adsConfig.set({
      footerBanner: false,
      interstitial: true,
    });
  });
</script>

<svelte:head>
  <title>Results · 27types</title>
</svelte:head>

<header>
  <div class="lead">Your Result</div>
  <h1 style="text-transform:uppercase;" class="mb-4">
    <Initialism
      initials={archetypesAbbreviations}
      dictWhatEveryLetterStandsFor={conversions}
    />
  </h1>

  <section class="mb-4">
    <GenderSelect></GenderSelect>
  </section>

  <h2>{archsCharsName}</h2>
</header>

<main>
  <section class="card shadow-lg">
    <div class="card-header">
      <h2 class="card-title">Your Stats</h2>
    </div>
    <div class="card-body">
      <StatsBars statsDict={Object.fromEntries(vangaurdguments.entries())} />
      <hr />
      <h3 class="mb-4">Your Percentiles</h3>
      <table class="table table-bordered shadow-sm">
        <thead>
          <tr>
            <th scope="col">Stat</th>
            <th scope="col">Percentile</th>
          </tr>
        </thead>
        <tbody>
          {#each Array.from(vangaurdguments.entries()) as [k, v], i}
            <tr>
              <td>{k}</td>
              <td
                >{(Math.round(percentilesArray?.[i] * 100) / 100).toFixed(
                  2
                )}</td
              >
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  </section>
  <section class="text-center">
    <GenderSelect></GenderSelect>
  </section>
  <section class="card shadow-lg">
    <ArchetypicalCharactersCard abbr={archetypesAbbreviations} />
  </section>
</main>

<footer>
  <Link to="/">
    <button class="btn btn-secondary shadow-sm">Back to Test</button>
  </Link>
  <Link to="/catalog">
    <button class="btn btn-warning btn-lg shadow">View The 27 Types</button>
  </Link>
  <Link to="/statistics">
    <button class="btn btn-info btn-lg shadow">Explore Statistics</button>
  </Link>
</footer>

<div hidden>
  <Test bind:this={testComponent} />
</div>

<style>
  th:last-child,
  td:last-child {
    text-align: end;
  }
</style>
